import { render } from "./VitSlide.vue?vue&type=template&id=6aab9ccf&ts=true"
import script from "./VitSlide.vue?vue&type=script&lang=ts"
export * from "./VitSlide.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__